import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { observer } from 'mobx-react-lite';

import { Page } from '../../../components/Page';
import { useStores } from '../../../models/root-store/root-store-context';
/** * ## Ir 설명 * */
export const Ir = observer(() => {
  const rootStore = useStores();
  const { loadingStore } = rootStore;
  const theme = useTheme();
  const pageTitle = 'INNERWAVE - Ir Screen';
  return (
    <Page title="{pageTitle}">
      <Box> {pageTitle} </Box>
    </Page>
  );
});
export default Ir;
